import { render } from "./table-added-products.vue?vue&type=template&id=75a256cb&ts=true"
import script from "./table-added-products.ts?vue&type=script&lang=ts&external"
export * from "./table-added-products.ts?vue&type=script&lang=ts&external"

import "./table-added-products.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__